import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const lmNewM3uApi = createApi({
  reducerPath: 'lmNewM3uApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['New M3U Links'],
  endpoints: builder => ({
    getNewM3uLinks: builder.query({
      query: (params) => ({
        url: `/links/new-m3u-links/`,
        params,
      }),
      providesTags: ['New M3U Links'],
    }),

    createNewM3uLink: builder.mutation({
      query: (formData) => ({
        url: '/links/new-m3u-links/',
        method: 'POST',
        body:formData
      }),
      invalidatesTags: ['New M3U Links'],
    }),
    updateNewM3uLink: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/new-m3u-links/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['New M3U Links'],
    }),
    getNewM3uLinkById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/links/new-m3u-links/${id}/`,
        params,
      }),
      providesTags: ['New M3U Links']
    }),
    getNewM3uLinksAggregateByCustomer: builder.query({
      
      query: () => {
        return `/links/new-m3u-links/aggregate-by-customer/`
      },
      providesTags: ['New M3U Links'],
    }),
    markNewM3uLinksEpisode: builder.mutation({
      query: body => ({
        url: `/links/new-m3u-links/mark/`,
        method: 'POST',
        body
      }),
       invalidatesTags: ['New M3U Links'],
    })
  }),
});

export const {
  useGetNewM3uLinksQuery,
  useCreateNewM3uLinkMutation,
  useUpdateNewM3uLinkMutation,
  useGetNewM3uLinkByIdQuery,
  useGetNewM3uLinksAggregateByCustomerQuery,
  useMarkNewM3uLinksEpisodeMutation
} = lmNewM3uApi;
